import instance from '../config/axios';
import { ShopifyCustomerAddress } from '../interface/interface';

export const cancelOrderProduct = (
  cancelOrder: number,
  reason: string,
  access_token?: string,
) =>
  instance({
    method: 'PUT',
    url: '/api/v1/order/cancel',
    data: { id: cancelOrder, reason },
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });

export const getRequestOrders = (
  pagination: { pageIndex: number; pageSize: number },
  search: string,
  access_token?: string,
) =>
  instance({
    method: 'GET',
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
    url: `api/v1/orders/getAllCancellationRequests?page=${pagination.pageIndex}&limit=${pagination.pageSize}&search=${search}`,
  });

export const deniedCancel = (
  deniedOrderProductId: number,
  reason: string,
  access_token?: string,
) =>
  instance({
    method: 'POST',
    url: '/api/v1/denied/cancel',
    data: { id: deniedOrderProductId, reason },
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });

export const getState = (access_token?: string) =>
  instance({
    method: 'GET',
    url: '/api/v1/states',
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });

export const getOrderHistoryByOrderId = (
  orderId: number,
  access_token?: string,
) =>
  instance({
    method: 'GET',
    url: `/api/v1/orderhistory/${orderId}`,
    headers: { Authorization: `Bearer ${access_token}` },
  });

export const requestForCancelOrder = (
  data: {
    orderId: number;
    reason: string;
    alternateAddress?: ShopifyCustomerAddress;
  },
  access_token?: string,
) =>
  instance({
    method: 'POST',
    url: '/api/v1/order/request-for-cancel',
    data,
    headers: { Authorization: `Bearer ${access_token}` },
  });

export const requestForDeletePrescription = (
  data: {
    prescriptionId: number;
    reason: string;
  },
  access_token?: string,
) =>
  instance({
    method: 'POST',
    url: '/api/v1/prescription/delete/request',
    data,
    headers: { Authorization: `Bearer ${access_token}` },
  });

export const getAllRequestData = (access_token: string) =>
  instance({
    method: 'GET',
    url: '/api/v1/fetch/delete/prescription',
    headers: { Authorization: `Bearer ${access_token}` },
  });

export const deleteRequestPrescription = (id: string, access_token: string) =>
  instance({
    method: 'DELETE',
    url: `/api/v1/delete/request/prescription/${id}`,
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });

export const deletePrescription = (id: number, access_token: string) =>
  instance({
    method: 'DELETE',
    url: `/api/v1/delete/prescription/${id}`,
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });

export const calleRx = (access_token: string) => {
  instance({
    method: 'POST',
    url: '/api/v1/request/eRx',
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};

export const getPatientDoctor = async (token: string) =>
  await instance.get('/api/v1/patient/doctors', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const checkeRxStatus = async (token: string) =>
  await instance.get('/api/v1/eRx/status', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const pendingRequest = async (token: string) =>
  await instance.get('/api/v1/admin/check/request/pending', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const deleteShippingAddress = async (addressId: number, customerId: number, token: string) =>
  await instance.delete(`/api/v1/customer/${customerId}/address/${addressId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
